<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-button v-if="addOpportunityBusinessCheck"
        @click=" $form('addOpportunityBusinessCheck')"
        size='small'
        type="primary"
        style="float:right"
        icon='el-icon-circle-plus'
      >添加填写项约束
      </el-button>
    </el-row>

    <mytable
      :tableColums='tableColums_getOpportunityBusinessCheckList'
      api='getOpportunityBusinessCheckList'
      xupdateapi='updateOpportunityBusinessCheck'
      :height="H-165" >
    </mytable> 

    <myform
      :viewobj='{
        addOpportunityBusinessCheck:    [ "新增填写项约束", "el-icon-circle-plus" ],
        updateOpportunityBusinessCheck: [ "修改填写项约束", "el-icon-edit-outline"],
        $succeed$: getOpportunityBusinessCheckList
      }'
      @close='$form("addOpportunityBusinessCheck","reset")'
      @confirm='myform' >
      <hide slot='obcId' />
      <hide slot='projectId' />
      <hide slot='obcKeyLabel' />
      <template v-slot:obcKey="{Myformdata}" >
        <el-select v-model='Myformdata.obcKey' clearable >
             <el-option
                v-for="item in obcKeyArray"
                :key="item.key"
                :label="item.label"
                :value="item.key">
            </el-option>
        </el-select>
  	  </template>
      <template v-slot:obcType="{Myformdata}" >
         <el-radio v-model="Myformdata.obcType" :label="obcKeyOne">字符</el-radio>
         <el-radio v-model="Myformdata.obcType" :label="obcKeyTwo">数字</el-radio>
  	  </template>
      <template v-slot:obcSize="{Myformdata}" >
         <el-input v-model="Myformdata.obcSize" type="number" placeholder="请输入数据长度"></el-input>
  	  </template>
      <template v-slot:obcMax="{Myformdata}" >
         <el-input v-model="Myformdata.obcMax" type="number" placeholder="请输入数据最大值"></el-input>
  	  </template>
    </myform>
  </div>
</template>

<script>
export default {
  data() {
    return {
      theProjectId: "",
      obcKeyOne:1,
      obcKeyTwo:2,
      obcKeyArray:[
        {key:"obMoney",label:"签约金额"},
        {key:"ouBusinessNum",label:"签约数量"},
        {key:"obYear",label:"签约年限"},
        {key:"obSet",label:"产品配置"},
        {key:"obOperator",label:"经办人员"},
        {key:"obOperatorPhone",label:"经办人员联系方式"},
      ],

      tableColums_getOpportunityBusinessCheckList: {
        $selection: false,

        // obcKey: '限制字段key',

        obcKeyLabel: '限制字段名称',

        obcType: ['数据格式',,'@v-if: 1:字符, 2:数字 '],

        obcSize: '数据长度',
        obcMax: '数字最大值',

        $operation: [
          '操作', 200,
          this.updateOpportunityBusinessCheck && `@text: 编辑#success
           @click: $form("updateOpportunityBusinessCheck",$row)
          `,
          this.deleteOpportunityBusinessCheck && `@text: 删除#danger
           @click: _confirm('确定要删除该填写项约束吗?')
                   .trigger('deleteOpportunityBusinessCheck',{obcId:$row.obcId})
                   .trigger('getOpportunityBusinessCheckList')
          `,
        ],

      },

    };
  },

  watch: {
    
  },

  methods: {
    myform(submit, Myformdata) {
      Myformdata.projectId = this.theProjectId;
      var obcKey = Myformdata.obcKey;
      this.obcKeyArray.forEach(element => {
        if(element.key==obcKey){
          Myformdata.obcKeyLabel=element.label;
        }
      });
      submit();
    },
  },

  created() {
    this.theProjectId=A.local('$projectId');
    this.getOpportunityBusinessCheckList({projectId:this.theProjectId});
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/model/BusinessCheckModel.vue